/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as FeedDefs from './defs.defs.js'

const $nsid = 'app.bsky.feed.getQuotes'

export { $nsid }

/** Get a list of quotes for a given post. */
const main = l.query(
  $nsid,
  l.params({
    uri: l.string({ format: 'at-uri' }),
    cid: l.optional(l.string({ format: 'cid' })),
    limit: l.optional(
      l.withDefault(l.integer({ minimum: 1, maximum: 100 }), 50),
    ),
    cursor: l.optional(l.string()),
  }),
  l.jsonPayload({
    uri: l.string({ format: 'at-uri' }),
    cid: l.optional(l.string({ format: 'cid' })),
    cursor: l.optional(l.string()),
    posts: l.array(l.ref<FeedDefs.PostView>((() => FeedDefs.postView) as any)),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output
